module.exports = __webpack_public_path__ + "img/reorderOff.7af06262.svg";